import React from "react";
import {
  inputFieldLock,
  labelLockStyle,
  labelLockVariants,
} from "./field-lock.css";

export function FieldLock({ checked, children, disabled, ...rest }) {
  return (
    <label
      className={`${labelLockStyle} ${
        labelLockVariants[disabled ? "disabled" : "enabled"]
      }`}
    >
      <input
        type="checkbox"
        checked={checked}
        {...rest}
        className={inputFieldLock}
        disabled={disabled}
      />
      {children}
    </label>
  );
}
